import Vue from 'vue';

import BaseButton from '~/components/base-button/BaseButton.vue';
import BaseInput from '~/components/base-input/BaseInput.vue';
import BaseMultiselect from '~/components/base-multiselect/BaseMultiselect.vue';

Vue.component('base-button', BaseButton);
Vue.component('base-input', BaseInput);
Vue.component('base-multiselect', BaseMultiselect);
